export const FEE_TEXT = {
  applicationFeeWaivedText: 'The applicant is exempt from the application fee.',
  applicationFeeHelperText:
    'Your application will be reviewed by the host academic department only after you have settled the payment. Please note that application fee is non-refundable.',
  registrationFeeHelperText:
    'To complete the "offer acceptance", please settle the registration fee.',
  tuitionFeeHelperText:
    'To complete the "registration preparation", please settle the tuition fee and caution money.',
  noteUnderDebitNote:
    'This registration fee is non-refundable and non-transferrable. It will be credited to your tuition fee, which will be payable upon your admission to the University. For scholarship recipients who are not required to pay a tuition fee, the registration fee will be refunded after commencement of study at PolyU.',
  debitNoteReady:
    'The debit note will be ready by the end of Sep 2024. Please check the debit note later.',
  tuitionFeeUnderText:
    'Before proceeding with programme registration, please settle the tuition fee and caution money (if any). <b>Fees paid will not be refunded</b> except in the case of programme cancellation and in the case of your qualifications acquired fall short of the requirements specified in a conditional offer.',
};
